import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import HomePresentational from './home-presentational';
import { images } from '@assets/img';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { onlyCRM } from '@constants';
import { isAuth, activeMenu } from '@helpers';

const HomeFunctional = ({ history, removeUser, userDetails }) => {
	const menuRoutes = [
		{
			name: 'Dashboard',
			route: '/dashboard',
			icon: images.dashboardicon,
		},
		{
			name: 'Profile',
			route: '/profile',
			icon: images.profileicon,
		},
		{
			name: 'Commission Management',
			route: '/commission-management',
			icon: images.commission,
		},
	];
	if (isAuth(onlyCRM, userDetails && userDetails.accessLevel)) {
		menuRoutes[2] = {
			name: 'Affiliate Management',
			route: '/affiliate-management',
			icon: images.affiliatemanagement,
		};
		menuRoutes[3] = {
			name: 'Commission Management',
			route: '/commission-summary',
			icon: images.commission,
		};
	}
	const [menuIndex, setmenuIndex] = useState(activeMenu(menuRoutes, history.location.pathname));
	const [collapsed, setcollapsed] = useState(true);
	const [confirmLogoutVisible, setconfirmLogoutVisible] = useState(false);

	useEffect(() => {
		setmenuIndex(activeMenu(menuRoutes, history.location.pathname));
	}, [history.location.pathname]);

	const handleCollapsed = () => setcollapsed(!collapsed);

	const handleLogoutModel = (value = false, logout = false) => {
		setconfirmLogoutVisible(value);
	};

	const handleLogout = () => {
		removeUser(userDetails.authKey, history);
		localStorage.removeItem('authKey');
		localStorage.removeItem('messages');
		localStorage.removeItem('authToken');
		localStorage.removeItem('userDetails');
	};

	const handleGoback = () => {
		history.go(-1);
	};

	const handleMenuClick = (route) => {
		history.push(route);
		if (window.screen.width <= 768) {
			setcollapsed(!collapsed);
		}
		setmenuIndex(activeMenu(menuRoutes, route));
	};

	const selectedRoute = () => [history.location.pathname.replace(/^(\/admin\/\w+)\/.*/, '$1')];

	return (
		<HomePresentational
			handleLogoutModel={handleLogoutModel}
			confirmLogoutVisible={confirmLogoutVisible}
			menuRoutes={menuRoutes}
			collapsed={collapsed}
			handleCollapsed={handleCollapsed}
			handleMenuClick={handleMenuClick}
			activeMenu={menuIndex}
			handleLogout={handleLogout}
			handleGoback={handleGoback}
			selectedKeys={[history.location.pathname]}
			selectedRoute={selectedRoute}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		removeUser: (authKey, history) => dispatch(ActionsApp.creators.removeUser(authKey, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(HomeFunctional);

export default Connected;
